<template>
  <v-card class="product-card d-flex flex-column" flat tile>
    <!-- Imagem do Produto -->
    <v-img
      class="product-image mx-auto mt-4"
      :src="imageUrl || placeholderImage"
      :alt="`Imagem do produto ${produto.nome}`"
      contain
    />

    <!-- Chips de Categoria -->
    <v-card-text class="card-text">
      <div class="d-flex flex-wrap justify-center gap-2">
        <v-chip
          v-for="categoriaId in produto.categorias"
          :key="categoriaId"
          small
          class="product-chip"
          :style="{
            backgroundColor: categoriasPorId[categoriaId]?.tagBackgroundColor || '#FF7A1F',
            color: categoriasPorId[categoriaId]?.tagForegroundColor || '#FFFFFF'
          }"
        >
          {{ categoriasPorId[categoriaId]?.name || `Categoria ${categoriaId}` }}
        </v-chip>
      </div>
    </v-card-text>

    <!-- Título do Produto -->
    <v-card-title class="text-center product-title px-4">
      {{ produto.nome }}
    </v-card-title>

    <!-- Botão Ver Manual -->
    <v-card-actions class="justify-center mt-auto mb-4">
  <v-btn class="gradient-button d-flex align-center justify-center" @click="verManual(produto)" rounded="pill">
    VER MANUAL
    <v-icon class="ml-2">mdi-arrow-right</v-icon>
  </v-btn>
</v-card-actions>

  </v-card>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";

const props = defineProps({
  produto: { type: Object, required: true },
  resourcesUrl: { type: String, required: true },
  categoriasPorId: { type: Object, default: () => ({}) },
});

const router = useRouter();
const screenWidth = ref(window.innerWidth);

const updateScreenWidth = () => (screenWidth.value = window.innerWidth);

onMounted(() => window.addEventListener("resize", updateScreenWidth));
onUnmounted(() => window.removeEventListener("resize", updateScreenWidth));

const imageUrl = computed(() => {
  const imagePath = screenWidth.value < 1201
    ? (props.produto.imagemMobile || props.produto.imagemDesktop)
    : (props.produto.imagemDesktop || props.produto.imagemMobile);
  return imagePath ? `${props.resourcesUrl}/${imagePath}` : null;
});

const placeholderImage = "/path/to/placeholder.png";

const slugify = (text) => {
  if (!text) return '';
  return text
    .toString() // Converte para string
    .normalize('NFD') // Separa os acentos das letras
    .replace(/[\u0300-\u036f]/g, '') // Remove os acentos
    .toLowerCase() // Converte para minúsculas
    .replace(/\s+/g, '-')           // Substitui espaços por hífens
    .replace(/[^\w-]+/g, '')       // Remove caracteres não-alfanuméricos (exceto -)
    .replace(/--+/g, '-')          // Substitui múltiplos - por um único -
    .replace(/^-+/, '')             // Remove - do início
    .replace(/-+$/, '');            // Remove - do fim
};

const verManual = (produto) => {
  const nomeSlug = slugify(produto.nome);
  router.push({ 
    name: 'ManualProduto', 
    params: { nome: nomeSlug },
    meta: { id: produto.id } // Passando o ID através do meta
  });
};
</script>

<style scoped>
/* Desktop (padrão) */
.v-card{
  width: 285px;
  background-color: #fff;
  border-radius: 9px;
  padding: 8px;
}

.v-card-text {
  flex:none;
  padding: 16px;
}

.product-image {
  width: 100%;
  height: 291px;
  object-fit: contain;
  border: 1px solid #e0e0e0;
  border-radius: 9px;
  margin: 16px auto 0 auto;
}

.product-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  padding: 0 16px;
}

.gradient-button {
  background: linear-gradient(45deg, #014d98 0%, #0593d4 100%);
  color: #fff;
  text-transform: uppercase;
  font-weight: 500;
  padding: 8px 2  0px;
  border-radius: 24px;
}

.v-chip.product-chip {
  font-size: 12px;
  font-weight: 500;
  height: 30px;
  border-radius: 16px;
  text-transform: none;
  padding: 16px 8px !important;
}

.v-card-actions {
  padding: 0;
  margin: 0; 
}

@media (max-width: 600px) {
  .product-image {
    height: 170px;
  }
}

@media (max-width: 485px) {
.gradient-button {
 font-size: 14px;
}

.v-chip.product-chip {
  font-size: 10px;
}
}

@media (max-width: 430px) {
.gradient-button {
 font-size: 10px;
 padding:  8px 16px!important;
 
}
.v-chip.product-chip {
  font-size: 8px;
  height: 16px;
  padding: 12px 6px !important;
}
}

@media (max-width: 368px) {
.product-image {
    height: 150px;
  }
  .gradient-button {
 font-size: 10px;
  padding: 0 32px;
}

.v-chip.product-chip {
  font-size: 7px;
  height: 15px;
  padding: 11px 5px !important;
}
}

@media (max-width: 310px) {
.v-chip.product-chip {
  font-size: 2px;
}
}
</style>
